export enum INDICATOR {
  DARK = '#42C54F',
  LIGHT = '#FF9900',
  BLUR = '#D8D8D8',
}
